<script lang="ts">
  import { loadJSON } from "../loader";

  interface DiscordWidgetJson {
    id: string;
    name: string;
    instant_invite: string;
    channels: { id: string; name: string; position: number }[];
    members: {
      id: string;
      username: string;
      discriminator: string;
      avatar: unknown;
      status: string;
      game?: {
        name: string;
      };
      avatar_url: string;
    }[];
    presence_count: number;
  }

  const rawDiscordData = loadJSON<DiscordWidgetJson>(
    "https://discordapp.com/api/guilds/613557484463849472/widget.json"
  );

  const botNames = ["Dyno", "Game Server Monitor", "Apollo"];

  const data = Promise.all([rawDiscordData]).then(([data]) => ({
    name: data.name,
    instantInvite: data.instant_invite,
    filteredMembers: data.members.filter(
      ({ username }) => !botNames.includes(username)
    ),
  }));
</script>

<main>
  {#await data}
    <div class="spinner" />
  {:then { name, filteredMembers, instantInvite }}
    <div class="header">
      <img
        class="discord-logo"
        src="/assets/discord_logo.png"
        alt="Discord Logo"
      />
      <div class="server-name">{name}</div>
    </div>
    <div class="sub-header">
      <div class="online">
        {filteredMembers.length} members online
      </div>
      <div class="join">
        <a href={instantInvite}>join our Discord server</a>
      </div>
    </div>

    <hr class="divider" />
    {#each filteredMembers as member}
      <div class="member">
        <div class="avatar" style="background-image: url({member.avatar_url});">
          <div class="status {member.status}" />
        </div>
        <div class="username">{member.username}</div>
        <div class="game">{member.game?.name || ""}</div>
      </div>
    {/each}
  {/await}
</main>

<style lang="scss">
  $online: rgb(56, 155, 88);
  $idle: rgb(240, 161, 25);
  $dnd: rgb(230, 64, 67);
  $offline: rgb(106, 116, 128);

  .header {
    display: flex;
    align-items: center;

    .discord-logo {
      width: 3rem;
    }

    .server-name {
      padding-left: 0.8rem;
      font-size: 1.6em;
    }
  }

  .sub-header {
    display: flex;
    align-items: center;

    .join {
      margin-left: auto;
      text-align: right;
    }
  }

  .member {
    display: flex;
    align-items: center;
    margin-top: 0.5rem;

    .avatar {
      height: 2rem;
      width: 2rem;
      border-radius: 50%;
      background-size: contain;

      .status {
        height: 0.8rem;
        width: 0.8rem;
        border-radius: 50%;
        box-shadow: 0px 0px 1px 1px black;
        position: relative;
        left: 1.2rem;
        top: 1.2rem;

        &.online {
          background-color: $online;
        }
        &.idle {
          background-color: $idle;
        }
        &.dnd {
          background-color: $dnd;
        }
        &.offline {
          background-color: $offline;
        }
      }
    }

    .username {
      padding-left: 0.8rem;
      font-size: 1.3em;
    }

    .game {
      margin-left: auto;
      opacity: 0.4;
      text-align: right;
    }
  }
</style>
